import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLockOff = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 3C9.79086 3 8 4.79086 8 7V10H19C20.6569 10 22 11.3431 22 13V20C22 21.6569 20.6569 23 19 23H5C3.34315 23 2 21.6569 2 20V13C2 11.3431 3.34315 10 5 10H6V7C6 3.68629 8.68629 1 12 1C14.5603 1 16.7461 2.60366 17.6076 4.86132C17.7967 5.35683 17.4684 5.8736 16.9542 6.00353C16.4004 6.14346 15.8525 5.77734 15.6042 5.26298C14.9576 3.92385 13.5867 3 12 3ZM4 13C4 12.4477 4.44772 12 5 12H19C19.5523 12 20 12.4477 20 13V20C20 20.5523 19.5523 21 19 21H5C4.44772 21 4 20.5523 4 20V13Z",
		fill: "white"
	})
});
export default SvgLockOff;
